import React from 'react';
import CheckBox from 'app/Components/Shared/CheckBox/Checkbox';
import ProductDescription from './ProductDescription';
import UpdatePaymentBanPaymentInfo from './UpdatePaymentBanPaymentInfo';

const UpdatePaymentBanSelectItem = ({ban, checked, onToggle}) => {
  const checkboxId = `update-payment-ban-${ban.banNumber}`;

  return (
    <div className={`update-payment-ban-item ${checked ? 'update-payment-ban-item--checked' : ''}`}>
      <CheckBox
        id={checkboxId}
        checked={checked}
        onCheck={() => onToggle(ban.banNumber, true)}
        onUncheck={() => onToggle(ban.banNumber, false)}
        customClassName='square update-payment-ban-item__checkbox'
        label={
          <div className='update-payment-ban-item__content'>
            <div className='update-payment-ban-item__ban-number bold'>חשבון {ban.banNumber}</div>
            <ProductDescription
              productDescriptions={ban.productDescriptions}
              banNumber={ban.banNumber}
              className='update-payment-ban-item__product s-title-small'
              tooltipIdPrefix='update-payment-ban-select'
            />
            <UpdatePaymentBanPaymentInfo ban={ban} block='update-payment-ban-item' layout='inline' size='small' />
          </div>
        }
      />
    </div>
  );
};

export default UpdatePaymentBanSelectItem;
